// extracted by mini-css-extract-plugin
export default {"wrapper":"Zl2ONyi8oePqOrbhhNTZ","collapseContainer":"rCr7Wh8BhuRL08QZeALW","title":"uQb0E9Cj4QZ8ejEThvnK","icon":"e_JvmgxIXJLbCPDmmNFi"};